import { PublicUserOrganization } from "../../../../__generated__/graphql";
import FullLoading from "../../../../components/FullLoading";
import useNav from "../../../../hooks/useNavigation";
import useOrganizationSharings from "../../../../hooks/useOrganizationSharings";
import CollaboratorCard from "./components/CollaboratorCard";

export default function CollaboratorsList() {
  const navigateWithLog = useNav();
  const { loading, error, data, externalUserOrganizations } =
    useOrganizationSharings();

  if (loading) return <FullLoading />;
  if (error) return <div>Error: {error.message}</div>;

  const collaboratorCard = (userOrganization: PublicUserOrganization) => {
    if (!userOrganization) return null;

    return (
      <CollaboratorCard
        userOrganization={userOrganization}
        onClick={() => navigateWithLog(`/collaborators/${userOrganization.id}`)}
      />
    );
  };

  return data?.organizationSharings?.length === 0 &&
    externalUserOrganizations?.length === 0 ? (
    <div className="text-secondary text-sm">Aucun collaborateur trouvé</div>
  ) : (
    <div className="mt-8 flex flex-wrap gap-4 justify-start">
      {externalUserOrganizations?.map((publicUserOrganization) => {
        if (!publicUserOrganization) return null;

        return (
          <div key={publicUserOrganization.id}>
            {collaboratorCard(publicUserOrganization)}
          </div>
        );
      })}
    </div>
  );
}
